import { render, staticRenderFns } from "./TurnsModal.vue?vue&type=template&id=df56221e&scoped=true&lang=pug"
import script from "./TurnsModal.vue?vue&type=script&lang=js"
export * from "./TurnsModal.vue?vue&type=script&lang=js"
import style0 from "./TurnsModal.vue?vue&type=style&index=0&id=df56221e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df56221e",
  null
  
)

export default component.exports